module.exports = __webpack_public_path__ + "assets/img/icon_tabnav_03_on.bb5f05c7.png";